import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import Code190Page from "./pages/Code190";
import Code46 from "./pages/Code46";
import Code23 from "./pages/Code23";
import AgeGate from "./pages/Age_detector/AgeGate";

export default function App() {
  return (
    <Router>
      {/* Wrap all routes with AgeGate */}
      <AgeGate>
        <Routes>
          <Route path="/" element={<HomePage />} />
           <Route path="/code23" element={<Code23 />} />
           <Route path="/code46" element={<Code46 />} />
          <Route path="/code190" element={<Code190Page />} />
        </Routes>
      </AgeGate>
    </Router>
  );
}
